import { Component, EventEmitter, Input, Output } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ModalController } from "ionic-angular";
import { AssessmentDataService } from "../../../../providers/asmt-data-service/asmt-data-service";
import { IntercardDataService } from "../intercard-data/intercard-data.service";
import { PainSiteService } from "../pain-site-card/pain-site.service";

@Component({
  selector: "wound-site-card",
  templateUrl: "wound-site-card.html",
})
export class WoundSiteCardComponent {
  @Input() painScreeningData: any;
  @Input() assessmentId: string;
  @Input() sectionId: string;
  @Input() config;
  @Input() disabled: boolean = false;
  @Output() onDataUpdate: EventEmitter<any> = new EventEmitter();

  id: string;
  label: string;
  access: string;
  declinable: boolean;
  painService;
  totalPoint: number = 0;
  hisV2: boolean = false;

  constructor(
    public modalCtrl: ModalController,
    public dataService: AssessmentDataService,
    public translatePipe: TranslateService,
    public intercard: IntercardDataService
  ) {
    // console.log('Hello PainSiteCardComponent Component');
  }

  ngOnInit(): void {
    // console.log( "Card config: " );
    // console.log( this.config );

    this.id = this.config.id;
    this.label = this.config.cardName;
    this.access = this.config.access;
    this.declinable = this.config.declinable;

    this.painService = new PainSiteService(this.config, this.translatePipe);

    if (this.config && this.config.hisV2) {
      this.hisV2 = this.config.hisV2;
    }
  }

  @Input() set data(incomingData: any) {
    // console.log( "Form card Data: ", this.data );
    // console.log( "Form card Incoming data: ", incomingData );
    if (incomingData) {
      // console.log( "Loaded data for pain site card: ", data );

      var array = incomingData.data;
      let cardData = array.reverse(function (a, b) {
        a = new Date(a.createDate);
        b = new Date(b.createDate);
        return a > b ? -1 : a < b ? 1 : 0;
      });

      if (cardData) {
        for (let data of cardData) {
          this.painService.addPointData(data);
        }
      }
    }
  }

  presentListForm(): void {
    let listModal = this.modalCtrl.create(
      "WoundModalPage",
      {
        config: this.config,
        painScreening: this.painScreeningData,
        totalPoint: this.totalPoint,
      },
      { enableBackdropDismiss: false }
    );
    let dataService = this.dataService;
    let painService = this.painService;
    let assessmentId = this.assessmentId;
    let sectionId = this.sectionId;
    let id = this.id;
    let intercard = this.intercard;
    let hisV2 = this.hisV2;

    listModal.onDidDismiss((data) => {
      // console.log( "Data returned from pain modal: ", data);
      if (data) {
        for (let item of data) {
          if (item["active"]) {
            delete item["active"]; //don't need to send this to backend
          }
          if (this.hisV2) {
            item.hisV2 = this.hisV2;
          }
        }

        let recordsToStore = JSON.parse(JSON.stringify(data));

        let storeRecord = function (record: object) {
          if (hisV2) {
            // Emmits an event so wasPainDoneQuestion can be marked as yes
            intercard.emitData("woundSiteCardPost", {});
          }
          dataService
            .storeRecord(assessmentId, sectionId, id, record)
            .subscribe((returnData) => {
              if (!returnData) {
                return;
              }

              let newData = returnData;
              // console.log( "New saved pain data: ", newData );
              painService.addPointData(newData);
              if (recordsToStore.length > 0) {
                storeRecord(recordsToStore.pop());
              }
            });
        };

        try {
          storeRecord(recordsToStore.pop());
        } catch (error) {
          //console.log( "Error during pain point data submission and building.", error );
        }
      }
    });
    listModal.present();
  }

  deletePoint(index: number) {
    // console.log( "Delete detected", index );

    let id = this.painService.getPoint(index).id;
    // console.log( "Deleting ID: ", id );

    this.dataService
      .deleteRecord(this.assessmentId, this.sectionId, this.id, id)
      .subscribe(() => {
        // console.log( "Removing point that matches: ", id );
        this.painService.removePoint(index);
      });
  }

  setTotalPoints(numOfPoints: number) {
    this.totalPoint = numOfPoints;
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/cards/wound-site-card/wound-site-card.ts